import React from 'react';
import { Radio } from 'components/RadioGroup';
import PropTypes from 'prop-types';

import { Wrapper, Title, Description } from './styles';

export default function AnonymizationLevelOption({
	value,
	keyValue,
	title,
	description,
	onChange,
	checked,
}) {
	return (
		<Wrapper checked={checked}>
			<Title>
				<Radio
					key={`option-${keyValue}`}
					value={value}
					onChange={onChange}
					checked={checked}
				>
					<span style={{ marginTop: '-2px' }}>{title}</span>
				</Radio>
			</Title>
			<Description>{description}</Description>
		</Wrapper>
	);
}

AnonymizationLevelOption.propTypes = {
	value: PropTypes.number.isRequired,
	keyValue: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	checked: PropTypes.bool.isRequired,
};
